import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/user-sign-in/types';

const initialState = Immutable.fromJS({
  signInEmail: undefined
});

export default reducerCreator(initialState, {
  [types.USER_SIGN_IN_RESET_STATE]: () => 
    initialState,

  [types.USER_SIGN_IN_SET_SIGN_IN_EMAIL]: (state, {signInEmail}) => 
    state.set('signInEmail', signInEmail),
});


// WEBPACK FOOTER //
// ./src/reducers/user-sign-in/user-sign-in.js